// extracted by mini-css-extract-plugin
module.exports = {"posts":"blog-module--posts--a25pe","post":"blog-module--post--1jMia"};